import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @memberOf Qualifiers.Flag
 * @extends {SDK.Qualifier}
 * @description the FlagQualifier class
 */
var FlagQualifier = /*#__PURE__*/function (_Qualifier) {
  function FlagQualifier(flagType, flagValue) {
    var _this;
    _classCallCheck(this, FlagQualifier);
    var qualifierValue;
    if (flagValue) {
      qualifierValue = new QualifierValue([flagType, "".concat(flagValue)]).setDelimiter(':');
    } else {
      qualifierValue = flagType;
    }
    _this = _callSuper(this, FlagQualifier, ['fl', qualifierValue]);
    _this.flagValue = flagValue;
    return _this;
  }
  _inherits(FlagQualifier, _Qualifier);
  return _createClass(FlagQualifier, [{
    key: "toString",
    value: function toString() {
      return _get(_getPrototypeOf(FlagQualifier.prototype), "toString", this).call(this).replace(/\./g, '%2E');
    }
  }, {
    key: "getFlagValue",
    value: function getFlagValue() {
      return this.flagValue;
    }
  }]);
}(Qualifier);
export { FlagQualifier };